

























import { mapState } from "vuex";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowRight from "@/common/components/icons/IconArrowRight.vue";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
    IconBase,
    IconArrowRight
  }
})
export default class HeaderMessage extends Vue {
  @Prop({ type: String, required: false }) message!: string;
  @Prop({ type: String, required: false }) url!: string;
}
